import React from 'react'
import { Controller } from 'react-hook-form'
import CitySearch from '../../../Common/CitySearch'
import { usePatientFormContext } from '../../context/PatientFormContext'

import PatientFormField from '../PatientFormField'
import { shouldDirty } from '../PatientIdentity/_utils/_utils'
import { City } from '../../../../hooks/_props'
import { useFormContextPatient } from '../_utils'
import { patientFormErrors } from '../../_errors'

const BirthCity = () => {
    const { control, getValues, setValue, clearErrors, setError, watch } = useFormContextPatient()

    const { birthDate } = getValues()
    const {
        state: { isDisabled },
    } = usePatientFormContext()

    const getValidableValue = (val: City | null) => {
        if (val === undefined || val === null) return undefined
        return Boolean(val.com) && Boolean(val.libelle) ? val : undefined
    }

    const watchCountry = watch('countryBirth.name')

    if (watchCountry?.toUpperCase() !== 'FRANCE') return null

    return (
        <Controller
            control={control}
            name="birthCity"
            rules={{
                required: String(patientFormErrors.birthCityLabel?.required),
                validate: (val) =>
                    getValidableValue(val) === undefined ? patientFormErrors.birthCityLabel?.required : true,
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="custom"
                    label="Code lieu de naissance (Code INSEE)"
                    name={field.name}
                    disabled={isDisabled}
                    status={{
                        error,
                        valid: !error && getValidableValue(field.value) !== undefined,
                    }}
                    required
                    render={() => (
                        <CitySearch
                            label="Recherche par nom de la ville"
                            onCitySearchChange={(city) => {
                                setValue(
                                    'birthCity',
                                    { com: city?.com ?? undefined, libelle: city?.libelle ?? undefined },
                                    shouldDirty,
                                )
                                clearErrors('birthCity')
                                if (!city) {
                                    setError('birthCity', {
                                        message: "Le lieu de naissance est obligatoire et n'a pas été renseigné",
                                    })
                                }
                            }}
                            onSearchValueChange={(search) => {
                                if (!search)
                                    setError('birthCity', {
                                        message: "Le lieu de naissance est obligatoire et n'a pas été renseigné",
                                    })
                            }}
                            birthDate={birthDate ? new Date(birthDate) : new Date()}
                            initialValue={field.value}
                            error={false}
                            disabled={isDisabled}
                        />
                    )}
                />
            )}
        />
    )
}

export default BirthCity
